<template>
    <div class="card shadow mb-3">
        <div class="card-body">
            <div class="row">
                <div class="col">
                    <a href="/experiencematrix" class="btn btn-secondary">{{ $trans.get('__JSON__.To experience') }}</a>
                                        <a :href="publicQualificationsLink" target="_blank" class="ml-2 btn btn-secondary" 
                        :title="$trans.get('__JSON__.Open public qualifications')" aria-label="Open public qualifications">
                        {{ $trans.get('__JSON__.Public qualifications') }} <span class="material-symbols-outlined m-0 p-0" data-bs-original-title="Jumbo">health_cross</span>
                    </a>
                </div>
                <div class="col-2">
                    <select v-if="teams" class="form-control" v-model="team_id" name="team_id" id="team_id">
                        <option :value="0" selected>{{ $trans.get("__JSON__.All teams") }}</option>
                        <option v-for="item in teams" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="col-2">
                    <select v-if="locations" class="form-control" v-model="location_id" name="team_id" id="team_id">
                        <option :value="0" selected>{{ $trans.get("__JSON__.All locations") }}</option>
                        <option v-for="item in locations" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>

                </div>
                <div class="col-2">
                    <input class="form-control" :placeholder="$trans.get('__JSON__.Filter name')" type="text"
                        v-model="employeeFilter" id="filter">
                </div>
            </div>
        </div>
    </div>

    <div class="card shadow">
        <div class="card-body">
            <ul class="nav nav-tabs">
                <li v-for="qualificationgroup in qualificationgroups" class="nav-item"
                    @click="setQualificationGroup(qualificationgroup.id)">
                    <span role="button" class="nav-link border border-bottom-0 rounded-2" :class="{
                        'active font-weight-bold': qualificationgroup.id == qualification_group_id,
                        'text-muted': qualificationgroup.id != qualification_group_id,
                    }">{{
                        qualificationgroup.name }}</span>
                </li>
            </ul>

            <table class="table table-striped panel">
                <thead>
                    <tr>
                        <th>{{ $trans.get('__JSON__.Name') }} / {{ $trans.get('__JSON__.Qualification') }}</th>
                        <template v-for="qualificationgroup in selectedQualifictionGroups">
                            <th role="button" class="text-center"
                                v-for="qualification in qualificationgroup.qualifications"
                                @click="changeSortOrder(qualification.id)"><span class="text-primary">{{
                                    qualification.name }}</span>&nbsp;{{
                                        countedEmployeesWithQualification[qualification.id]
                                    }}/{{ countedEmployees }}&nbsp;
                                <i v-if="Math.abs(sortQualification) != qualification.id" class="fa fa-sort"></i>
                                <i v-if="sortQualification == qualification.id" class="fa fa-sort-up"></i>
                                <i v-if="sortQualification * -1 == qualification.id" class="fa fa-sort-down"></i>
                            </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="employee in filteredEmployees" :key="employee.id">
                        <td>
                            <div class="employeetaskline grow d-flex">
                                <employee employeelink="1" :employee="employee" />
                            </div>
                        </td>

                        <template v-for="qualificationgroup in selectedQualifictionGroups">
                            <td class="text-center" v-for="qualification in qualificationgroup.qualifications"
                                :key="employee.id + '-' + qualificationgroup.id + '-' + qualification.id"
                                @click="editEmployeeQualification(employee.id, qualification.id)">
                                <qualification-cell
                                    :employeequalification="getEmployeeQualification(employee.id, qualification.id)"
                                    :warningdays="parsedwarningdays" />
                            </td>

                        </template>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal" tabindex="-1" id="qualificationmodal">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">
                        {{ $trans.get("__JSON__.Edit qualification") }}
                    </h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div v-if="this.actualQualification" class="modal-body">
                    <div v-if="employee" class="row">
                        <div class="col-6">
                            <h4>{{ employee.lastname }}, {{ employee.forename }}</h4>
                            <h4 v-if="qualification && qualification_group_id > 0">{{ getQualificationGroup()?.name }}
                                {{ qualification.name }}</h4>
                            <h5 class="text-danger" v-if="this.actualQualification.old == true"> {{
                                $trans.get("__JSON__.Attention! Viewing deleted qualification info!") }}</h5>
                        </div>
                        <div class="col-6">
                            <h4>{{ $trans.get('__JSON__.Files') }}</h4>
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>{{ $trans.get('__JSON__.Files') }}</th>
                                        <th>{{ $trans.get('__JSON__.File Stat') }}</th>
                                        <th class="text-end">{{ $trans.get('__JSON__.Actions') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="file in files">
                                        <td :class="{ 'text-danger': file.stat == 'old' }">
                                            {{ file.name }}
                                        </td>
                                        <td :class="{ 'text-danger': file.stat == 'old' }">
                                            {{ file.stat }}
                                        </td>
                                        <td class="text-end">
                                            <a class="me-2"
                                                :href="'/uploads/open?folder=qualifications&filename=' + file.name + '&modelId=' + file.modelId"
                                                target="_new"><i class="fa fa-eye"></i></a>
                                            <a class="me-2"
                                                :href="'/uploads/download?folder=qualifications&filename=' + file.name + '&modelId=' + file.modelId"><i
                                                    class="fa fa-download"></i></a>
                                            <a v-if="can('qualification-document-delete')"
                                                :href="'/uploads/delete?folder=qualifications&filename=' + file.name + '&hash=' + file.hash + '&modelId=' + file.modelId + '&Id=' + file.Id"><i
                                                    class="fa fa-trash"></i></a>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            <div v-if="success != ''" class="alert alert-success" role="alert">
                                {{ success }}
                            </div>
                            <div v-if="errors != null" class="alert alert-danger" role="alert">
                                <div v-for="error in errors"> {{ error[0] }} </div>
                            </div>
                            <form
                                v-if="actualQualification && actualQualification.id > 0 && can('qualification-document-add')"
                                @submit="formSubmit" enctype="multipart/form-data">
                                {{ $trans.get('__JSON__.Add file') }}
                                <input type="file" class="form-control" v-on:change="onFileChange">

                                <button v-bind:disabled='!isDisabled' class="btn btn-success">{{
                                    $trans.get('__JSON__.Upload file') }}</button>
                            </form>
                        </div>
                    </div>
                    <div v-if="actualQualification" class="row">
                        <div class="col-3">
                            <label for="start_at">{{ $trans.get('__JSON__.Start at') }}</label>
                            <input class="form-control" type="date" v-model="actualQualification.start_at" id="start_at"
                                :max="new Date().toISOString().split('T')[0]">
                        </div>
                        <div class="col-3" v-if="qualification.refresh_interval && qualification.refresh_unit > 0">
                            <label for="refresh_at">{{ $trans.get('__JSON__.Refresh at') }}</label>
                            <input class="form-control" type="date" v-model="actualQualification.refresh_at"
                                id="refresh_at">
                        </div>
                        <div class="col-6 d-flex align-items-end">
                            <button v-if="qualification.refresh_interval && qualification.refresh_unit > 0"
                                @click="manualRenew" class="btn btn-primary me-2" style="bottom: 0px;">
                                {{ $trans.get('__JSON__.manual renew') }}
                            </button>
                            <div class="dropdown" v-if="actualQualification && !actualQualification.old">
                                <button v-bind:disabled='isDeleted' class="btn btn-danger dropdown-toggle" type="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    {{ $trans.get('__JSON__.End qualification') }}
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#" @click="manualEndNow">
                                            {{ $trans.get('__JSON__.end immediately') }}</a></li>
                                    <li v-if="actualQualification.refresh_at"><a id="end_later_option"
                                            class="dropdown-item" @click="manualEndAtEnd" href="#">
                                            {{ $trans.get('__JSON__.end at end of qualification') }}</a></li>
                                </ul>
                            </div>
                            <button v-if="qualification.fast_singletraining" @click="singleTrainingHandler"
                                class="btn btn-primary-lighter ms-2" style="bottom: 0px;">
                                {{ $trans.get('__JSON__.Single Training') }}
                            </button>
                        </div>
                    </div>
                    <div v-if="actualQualification && actualQualification.refresh_at" class="row">
                        <div class="col-3">
                            <label for="paused">{{ $trans.get('__JSON__.Paused') }}</label>
                            <select class="form-control" v-model="actualQualification.paused" id="disabled">
                                <option value="0">{{ $trans.get('__JSON__.No') }}</option>
                                <option value="1">{{ $trans.get('__JSON__.Yes') }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="actualQualification" class="row mb-3">
                        <div class="col-12">
                            <label for="comment">{{ $trans.get('__JSON__.Comment') }}</label>
                            <input class="form-control" type="text" v-model="actualQualification.comment" id="start_at">
                        </div>
                    </div>

                    <div v-if="actualQualification" class="row mb-3">
                        <div class="col-12">
                            <label for="publish">{{ $trans.get('__JSON__.Publish') }}</label>
                            <select class="form-control" v-model="actualQualification.publish" id="publish">
                                <option value="0">{{ $trans.get('__JSON__.No') }}</option>
                                <option value="1">{{ $trans.get('__JSON__.Yes') }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="mt-2">
                        <div class="d-flex flex-start">
                            <h4 class="mt-1">{{ $trans.get('__JSON__.Publish information') }}</h4>
                            <span class="material-symbols-outlined text-danger ml-2" style="font-size:25px;" v-tooltip
                                :title="$trans.get('__JSON__.This information is openly displayed at the information screens across the different locations.')">
                                release_alert
                            </span>
                        </div>
                        <div class="row">
                            <div class="col-12 mb-3">
                                <textarea v-model="actualQualification.publish_information" id="publish_information"
                                    name="publish_information">
                            </textarea>
                            </div>
                        </div>
                    </div>

                    <div v-if="actualQualification" class="row mb-3">
                        <div class="col-12">
                            <label for="disabled">{{ $trans.get('__JSON__.Enabled/Disabled') }}</label>
                            <select class="form-control" v-model="actualQualification.disabled" id="disabled">
                                <option value="0">{{ $trans.get('__JSON__.Enabled') }}</option>
                                <option value="1">{{ $trans.get('__JSON__.Disabled') }}</option>
                            </select>
                        </div>
                    </div>

                    <div v-if="errors" class="alert alert-danger" role="alert">
                        <div v-for="(v, k) in errors" :key="k">
                            <p v-for="error in v" :key="error">
                                {{ error }}
                            </p>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger float-left" @click="deleteQualification">
                        <i class="fa fa-trash"></i>
                    </button>
                    <button v-if="isDeleted == false" type="button" class="btn btn-primary" @click="saveQualification">
                        {{ $trans.get("__JSON__.Save") }}
                    </button>
                    <button v-if="isDeleted == true" type="button" class="btn btn-primary" @click="manualRenew">
                        {{ $trans.get("__JSON__.Renew") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from "vue";
import getTeams from "../composables/getTeams";
import getLocations from "../composables/getLocations";
import getEmployees from "../composables/getEmployees";
import getQualificationGroups from "../composables/getQualificationGroups";
import singleTraining from '../composables/singleTraining';
import "summernote/dist/summernote.css";
import "summernote/dist/summernote-bs5.min.js";


export default {
    name: "QualificationMatrix",
    props: {
        warningdays: String
    },
    setup(props) {
        const { teams, teams_error, loadTeams } = getTeams();
        loadTeams();

        const { locations, locations_error, loadLocations } = getLocations();
        loadLocations();

        const { employees, employees_error, loadEmployees } = getEmployees();
        loadEmployees(null, [
            'qualifications', 'employer'
        ]);

        const { qualificationgroups, qualificationgroups_error, loadQualificationGroups } = getQualificationGroups();
        loadQualificationGroups();

        const { singleTrainingResponse, singleTraining_error, addEmployeeResponse, addEmployee_error, create, addEmployee } = singleTraining();


        return { teams, locations, employees, qualificationgroups, loadEmployees, singleTrainingResponse, singleTraining_error, addEmployeeResponse, addEmployee_error, create, addEmployee };
    },
    computed: {
        selectedQualifictionGroups() {
            if (this.qualification_group_id > 0) {
                return [this.qualificationgroups.find((item) => item.id == this.qualification_group_id)];
            }
            return this.qualificationgroups;
        },
        filteredEmployees() {
            if (this.employees) {
                this.sortEmployeesByQualificationDate(this.sortQualification);
            }

            if (this.employeeFilter == '') {
                return this.employees;
            }

            return this.employees.filter((item) => item.forename.toLowerCase().includes(this.employeeFilter.toLowerCase()) || item.lastname.toLowerCase().includes(this.employeeFilter.toLowerCase()));

        },
        countedEmployees() {
            if (this.filteredEmployees) {
                return this.filteredEmployees.length;
            }
            return 0;
        },
        countedEmployeesWithQualification() {
            var qualifiedEmployees = [];
            if (this.filteredEmployees) {
                if (this.selectedQualifictionGroups[0].qualifications) {
                    this.selectedQualifictionGroups[0].qualifications.forEach(qualification => {
                        qualifiedEmployees[qualification.id] = this.filteredEmployees.filter((employee) => this.hasQualification(employee.id, qualification.id)).length;
                    });
                }
            }
            return qualifiedEmployees;
        },
        isDisabled() {
            return this.actualQualification?.id > 0;
        },
        isDeleted() {
            return this.actualQualification?.old == true;
        },
        publicQualificationsLink() {
            if (!this.location_id) {
                return '/public/qualifications';
            }
            const params = new URLSearchParams({ location_id: this.location_id ?? 0 });
            return `/public/qualifications?${params.toString()}`;
        }

    },
    methods: {
        singleTrainingHandler() {
            let trainingBase = {
                qualification_id: this.qualification.id,
                qualification_name: this.qualification.name,
                employee_name: this.employee.lastname + ' ' + this.employee.forename,
                employee_id: this.employee.id,
            };
            this.create(trainingBase);
        },
        editEmployeeQualification(employee_id, qualification_id) {
            $(".tooltip").css('display', 'none');

            this.employee = this.employees.find((item) => item.id == employee_id);
            this.qualification = this.getQualification(qualification_id);

            this.actualQualification = this.getEmployeeQualification(employee_id, qualification_id);

            if (this.actualQualification == null) {
                this.actualQualification = {
                    id: null,
                    employee_id: employee_id,
                    qualification_id: qualification_id,
                    start_at: null,
                    refresh_at: null,
                    comment: null,
                    training_at: null,
                    training_location: null,
                    old: false,
                    disabled: false,
                    paused: false,
                };
            } else {
                this.loaded = true;

                this.actualQualification.start_at = this.formatDate(this.actualQualification.start_at);
                if (this.actualQualification.refresh_at) {
                    this.actualQualification.refresh_at = this.formatDate(this.actualQualification.refresh_at);
                }
            }
            this.getFiles();
            $('#qualificationmodal').modal('show');
        },
        deleteQualification() {
            if (confirm(this.$trans.get('__JSON__.Are you sure you want to delete the employe qualification?'))) {
                this.errors = null;
                axios
                    .delete("/api/employeequalifications/" + this.actualQualification.id)
                    .then((resp) => {
                        $("#qualificationmodal").modal("hide");
                        this.actualQualification = null;
                        this.loadEmployees([
                            ['team_id', this.team_id],
                            ['location_id', this.location_id],
                        ], ['qualifications', 'employer']);
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    });
            }
        },
        saveQualification() {
            this.errors = null;

            if (this.actualQualification.id != null) {
                if (this.actualQualification.old == true) {
                    this.actualQualification.old = false;
                }
                axios
                    .put("/api/employeequalifications/" + this.actualQualification.id, this.actualQualification)
                    .then((resp) => {
                        $("#qualificationmodal").modal("hide");
                        this.actualQualification = null;
                        this.loadEmployees([
                            ['team_id', this.team_id],
                            ['location_id', this.location_id],
                        ], ['qualifications', 'employer']);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.errors = error.response.data.errors;
                    });
            } else {
                axios
                    .post("/api/employeequalifications", this.actualQualification)
                    .then((resp) => {
                        $("#qualificationmodal").modal("hide");
                        this.actualQualification = null;
                        this.loadEmployees([
                            ['team_id', this.team_id],
                            ['location_id', this.location_id],
                        ], ['qualifications', 'employer']);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.errors = error.response.data.errors;
                    });
            }

        },
        manualRenew() {
            axios
                .post("/api/employeequalifications/renew", this.actualQualification)
                .then((resp) => {
                    $("#qualificationmodal").modal("hide");
                    this.actualQualification = null;
                    this.loadEmployees([
                        ['team_id', this.team_id],
                        ['location_id', this.location_id],
                    ], ['qualifications', 'employer']);
                })
                .catch((error) => {
                    console.log(error);
                    this.errors = error.response.data.errors;
                });
        },
        manualEndNow() {
            console.log("manualEndNow");
            console.log('actualqualification', this.actualQualification);
            this.actualQualification.old = 1;
            axios
                .put("/api/employeequalifications/" + this.actualQualification.id, this.actualQualification)
                .then((resp) => {
                    $("#qualificationmodal").modal("hide");
                    this.actualQualification = null;
                    this.loadEmployees([
                        ['team_id', this.team_id],
                        ['location_id', this.location_id],
                    ], ['qualifications', 'employer']);
                })
                .catch((error) => {
                    console.log(error);
                    this.errors = error.response.data.errors;
                });
        },
        manualEndAtEnd() {
            console.log("refresh_at: ", this.actualQualification.refresh_at);
            this.actualQualification.end_at = this.actualQualification.refresh_at;
            console.log("end_at: ", this.actualQualification.end_at);
            axios
                .put("/api/employeequalifications/" + this.actualQualification.id, this.actualQualification)
                .then((resp) => {
                    $("#qualificationmodal").modal("hide");
                    this.actualQualification = null;
                    this.loadEmployees([
                        ['team_id', this.team_id],
                        ['location_id', this.location_id],
                    ], ['qualifications', 'employer']);
                })
                .catch((error) => {
                    console.log(error);
                    this.errors = error.response.data.errors;
                });
        },
        getQualificationGroup() {
            return this.qualificationgroups.find((item) => item.id == this.qualification_group_id);
        },
        getQualification(qualification_id) {
            for (let qualificationGroup of this.qualificationgroups) {
                const qualification = qualificationGroup.qualifications.find((item) => item.id == qualification_id);
                if (qualification) {
                    return qualification;
                }
            }
            return null;
        },
        setQualificationGroup(qualificationGroupId) {
            this.qualification_group_id = qualificationGroupId;
        },
        hasQualification(employeeId, qualificationId) {
            const employee = this.employees.find((item) => item.id == employeeId);
            if (employee) {
                if (employee.qualifications) {
                    const employeeQualification = employee.qualifications.find((item) => item.qualification_id == qualificationId);
                    if (employeeQualification) {
                        return true;
                    }
                }
            }
            return false;
        },
        getEmployeeQualification(employeeId, qualificationId) {
            const employee = this.employees.find((item) => item.id == employeeId);
            if (employee) {
                if (employee.qualifications) {
                    const oldEmployeeQualification = employee.oldqualifications.find((item) => item.qualification_id == qualificationId);
                    if (oldEmployeeQualification) {
                        const employeeQualification = employee.qualifications.find((item) => item.qualification_id == qualificationId);
                        if (employeeQualification) {
                            return employeeQualification;
                        }
                        else {
                            return oldEmployeeQualification;
                        }
                    }
                    else {
                        const employeeQualification = employee.qualifications.find((item) => item.qualification_id == qualificationId);
                        if (employeeQualification) {
                            return employeeQualification;
                        }
                    }
                }
            }
            return null;
        },
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },
        sortEmployeesByQualificationDate(qualificationId) {
            const direction = (qualificationId < 0) ? -1 : 1;
            const searchQualificationId = Math.abs(qualificationId);

            this.employees.sort(function (firstEmployee, secondEmployee) {
                if (qualificationId == 0) {
                    const firstEmployeeName = firstEmployee.lastname + "-" + firstEmployee.forename;
                    const secondEmployeeName = secondEmployee.lastname + "-" + secondEmployee.forename;
                    if (firstEmployeeName > secondEmployeeName) {
                        return 1;
                    }
                    if (firstEmployeeName < secondEmployeeName) {
                        return -1;
                    }
                    return;
                }

                const firstQualification = firstEmployee.qualifications.find((item) => item.qualification_id == searchQualificationId);
                const secondQualification = secondEmployee.qualifications.find((item) => item.qualification_id == searchQualificationId);
                console.log(firstQualification?.start_at, secondQualification?.start_at);

                if (!firstQualification && !secondQualification) {
                    return;
                }

                if (!firstQualification) {
                    return 1 * direction;
                }

                if (!secondQualification) {
                    return -1 * direction;
                }

                const firstStartDate = new Date(firstQualification.start_at);
                console.log('firstStartDate', firstStartDate);
                const secondStartDate = new Date(secondQualification.start_at);
                console.log('secondStartDate', secondStartDate);

                if (firstStartDate > secondStartDate) {
                    return 1 * direction;
                }

                if (firstStartDate < secondStartDate) {
                    return -1 * direction;
                }
            });

        },
        changeSortOrder(qualificationId) {

            if (this.sortQualification == 0 || Math.abs(this.sortQualification) != qualificationId) {
                this.sortQualification = qualificationId;
                this.sortEmployeesByQualificationDate(this.sortQualification);
                return;
            }

            if (this.sortQualification == qualificationId) {
                this.sortQualification = qualificationId * -1;
                this.sortEmployeesByQualificationDate(this.sortQualification);
                return;
            }

            if (this.sortQualification == qualificationId * -1) {
                this.sortQualification = 0;
                this.sortEmployeesByQualificationDate(this.sortQualification);
                return;
            }
        },
        onFileChange(e) {
            console.log(e.target.files[0]);
            this.file = e.target.files[0];
        },
        formSubmit(e) {
            e.preventDefault();
            let currentObj = this;
            currentObj.success = '';

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('prefix', this.actualQualification.employee_id + '-' + this.actualQualification.qualification_id);
            // formData.append('name', this.name);
            formData.append('folder', 'qualifications');
            formData.append('qualificationId', this.actualQualification.qualification_id);
            formData.append(`employee_id`, this.actualQualification.employee_id);
            formData.append('model_id', this.actualQualification.id);
            formData.append('model_type', 'App\\Models\\EmployeeQualification (EmployeeQualification::class)');

            axios.post('/uploads', formData, config)
                .then(function (response) {
                    currentObj.success = response.data.success;
                    currentObj.getFiles();
                    currentObj.errors = null;
                })
                .catch(function (error) {
                    if (error.response.status == 413) {
                        console.log(error.response.data.errors);
                        currentObj.errors = { errors: [currentObj.$trans.get('__JSON__.Request Entity Too Large')] };
                    } else {
                        currentObj.errors = error.response.data.errors;
                    }
                });
        },
        getFiles() {
            let currentObj = this;

            //console.log('try getting files');
            axios.get('/uploads/directory', {
                params: {
                    prefix: this.actualQualification.employee_id + '-' + this.actualQualification.qualification_id,
                    folder: 'qualifications',
                    model_type: 'App\\Models\\EmployeeQualification (EmployeeQualification::class)',
                    employee_id: this.actualQualification.employee_id,
                    model_id: this.actualQualification.id,
                    qualificationId: this.actualQualification.qualification_id
                }
            })
                .then(function (response) {
                    currentObj.files = response.data.files;
                    //console.log('error: ' , currentObj.files);
                })
                .catch(function (error) {
                    currentObj.output = error;
                    console.log('error: ', currentObj.output)
                });
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
        singleTrainingResponse: function (newValue, oldValue) {
            if (newValue) {
                this.training = newValue;
                let employeeData = {
                        employee_id: this.employee.id,
                        training_id: this.training.id,
                    };
                    this.addEmployee(employeeData);
            } else {
                this.training = [];
            }
        },
        addEmployeeResponse: function (newValue, oldValue) {
            if (newValue) {
                 document.location.href = '/trainings/' + this.training.id + '/edit'
            } 
        },
        team_id: function (newValue, oldValue) {
            this.loadEmployees([
                ['team_id', newValue],
                ['location_id', this.location_id],
            ], ['qualifications', 'employer']);

        },
        location_id: function (newValue, oldValue) {
            this.loadEmployees([
                ['team_id', this.team_id],
                ['location_id', newValue],
            ], ['qualifications', 'employer']);

        },
        qualificationgroups: function (newValue, oldValue) {
            console.log('Change qualificationgroups');
            if (oldValue == null) {
                this.qualification_group_id = this.qualificationgroups[0].id;
            }
        },
        actualQualification(newVal, oldVal) {
            if (newVal) {
                this.$nextTick(() => {
                    $('#publish_information').summernote({
                        tabsize: 2,
                        height: 200,
                        toolbar: [
                            ['style', ['style', 'bold', 'italic', 'underline', 'clear']],
                            ['font', ['strikethrough', 'superscript', 'subscript']],
                            ['fontsize', ['fontsize']],
                            ['fontname', ['fontname']],
                            ['alignment', ['ul', 'ol', 'paragraph']],
                            ['height', ['height']],
                            ['color', ['color']],
                            ['para', ['ul', 'ol', 'paragraph']],
                            ['table', ['table']],
                        ],
                        popover: false,
                        callbacks: {
                            onChange: (contents) => {
                                this.actualQualification.publish_information = contents;
                            }
                        }
                    });
                });
            }
        },
        /* const INTERVALS = [
            1 => 'days',
            2 => 'months',
            3 => 'years'
        ];
        */
        'actualQualification.start_at': {
            handler(newValue, oldValue) {
                if (newValue) {
                    const qualification = this.getQualification(this.actualQualification.qualification_id);
                    console.log("Values", newValue, oldValue);
                    console.log("Loaded", this.loaded);
                    if (!this.loaded) {
                        if (newValue && qualification.refresh_interval) {
                            var startDate = new Date(newValue);
                            if (qualification.refresh_unit == 1) {
                                this.actualQualification.refresh_at = this.formatDate(startDate.setDate(startDate.getDate() + qualification.refresh_interval));
                            }
                            if (qualification.refresh_unit == 2) {
                                this.actualQualification.refresh_at = this.formatDate(startDate.setMonth(startDate.getMonth() + qualification.refresh_interval));
                            }
                            if (qualification.refresh_unit == 3) {
                                this.actualQualification.refresh_at = this.formatDate(startDate.setYear(startDate.getYear() + qualification.refresh_interval));
                            }
                        }
                    }
                    this.loaded = false;
                }
            }
        }
    },
    data() {
        return {
            qualification_group_id: 0,
            team_id: 0,
            location_id: 0,
            errors: null,
            employee: null,
            qualification: null,
            actualQualification: null,
            sortQualification: 0,
            employeeFilter: '',
            parsedwarningdays: null,
            loaded: false,
            training: [],
            name: '',
            file: '',
            success: '',
            error: null,
            files: [],
        };
    },
};
</script>

<style scoped lang="scss">
//.upright {
// writing-mode: vertical-rl;
//    transform-origin: 0 0;
//    transform: rotate(270deg);
//}

td .hoverplus {
    display: none;
}

td:hover .hoverplus {
    display: block;
}

.nav-item:hover {
    background-color: lightgray;
}
</style>
